import Button from 'components/_parts/atoms/button';
import CustomTable from 'components/_parts/atoms/table';
import dayjs from 'dayjs';
import styled from 'styled-components';
import dataStatus from './dataStatus';

const ButtonEdit = styled(Button)`
  width: 100%;
  max-width: 70px;
  height: 24px;
  float: right;
`;

const customStyles = {
  headCells: {
    style: {
      fontSize: '12px',
      fontWeight: 'bold',
      textAlign: 'center',
      fontFamily: 'Quicksand',
      padding: '0px',
      justifyContent: 'start',
    },
  },
  cells: {
    style: {
      padding: '0px',
      justifyContent: 'start',
    },
  },
  rows: {
    style: {
      fontFamily: 'Quicksand',
      minHeight: '35px', // override the row height
      borderRadius: 0,
      filter: 'none',
      borderBottom: 'unset !important',
    },
  },
};
const CustomTableMod = styled.div`
  [data-column-id="1"] {
    min-width: 10%;
    tex-align: left;
  }
  .rdt_TableBody {
    max-height: 250px;
    overflow: auto;
  }
`;

function Table(props) {
  const { t } = props;
  const columns = [
    {
      name: 'No',
      sortField: true,
      selector: (_, i) => i + 1,
      cellStyle: { verticalAlign: 'middle' },
      width: 'fit-content',
      style: {
        fontWeight: '800',
      },
    },
    {
      name: t('biz_process.tree.title'),
      sortField: true,
      selector: (row) => row.title,
    },
    {
      name: t('job_desc.status'),
      sortField: true,
      selector: (row) => (
        <div className="custom_wla-collapsible-content-right-status">
          {dataStatus({ data: row.status, t: t })}
        </div>
      ),
    },
    {
      name: t('job_desc.last_update'),
      sortField: true,
      selector: (row) => dayjs(row.updated_at).format('D MMM YYYY') ?? '-',
      center: true,
      width: '20%',
    },
    {
      name: t('org.employee.action'),
      sortField: true,
      style: {
        justifyContent: 'center',
      },
      center: true,
      selector: (row) => 'der',
      width: '15%',
      cell: (row, i) => (
        <ButtonEdit
          icon="edit"
          func={() => {
            props.setShowModal(!props?.showModal);
            props?.setTypeForm('edit-sub');
            props?.setId(i);
            props?.setSelectedData(props?.data[i]);
          }}
        >
          &nbsp;&nbsp;{t('org.structure_view.modal.edit')}
        </ButtonEdit>
      ),
    },
  ];

  return (
    <CustomTableMod>
      <CustomTable
        columns={columns}
        subHeader={false}
        isFixHeader={false}
        noHeader
        data={props?.data}
        customStyles={customStyles}
      />
    </CustomTableMod>
  );
}

export default Table;
